import React from "react";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { Topbar } from "@components";
import styled from "styled-components";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { useTranslation } from "react-i18next";
import { localStorage } from "@utils";
import { ENGLISH_LANGUAGE_CODE_LK, BURMESE_LANGUAGE_CODE_LK } from "@constants";

const RootContainer = styled.div`
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.div`
  color: #101415;
  text-align: center;
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  width: fit-content;
  padding: 7px 18px;
  border-radius: 24px;
  background-color: #EFEFEF;
  margin-bottom: 12px;
`

const RulesContainer = styled.div`
  span{
    color: #101415;
    font-family: Plus Jakarta Sans;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 168%;
  }
`

const Rules = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();
  const userPreferedLanguage = localStorage.getUserPreferedLanguage();

  const goBack = () => {
    navigate(`/${PUBLIC_ROUTE.SPIN_HOME}`);
  };

  if (!state) {
    return <Navigate to={`/${PUBLIC_ROUTE.SPIN_HOME}`} />;
  }

  const ruleText =
    userPreferedLanguage === ENGLISH_LANGUAGE_CODE_LK
      ? state.text_en
      : userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK
        ? state.text_mm
        : state.text_ch;
  return (
    <>
      <Topbar title={t("spin.rule")} goBack={goBack} />
      <RootContainer>
        <Title> {t("spin.ruleTitle")} </Title>
        <RulesContainer dangerouslySetInnerHTML={{ __html: ruleText }} />
      </RootContainer>
    </>
  );
};

export default Rules;
